import { render, staticRenderFns } from "./basicDialog.vue?vue&type=template&id=4bdbb383&scoped=true&lang=pug"
import script from "./basicDialog.vue?vue&type=script&lang=ts"
export * from "./basicDialog.vue?vue&type=script&lang=ts"
import style0 from "./basicDialog.vue?vue&type=style&index=0&id=4bdbb383&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbb383",
  null
  
)

export default component.exports